module.exports = __webpack_public_path__ + "img/right.790bc91c.png";